import { MenuItem } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import {
  type ProjectWipExportQueryVariables,
  useProjectWipExportLazyQuery,
} from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { observer } from "mobx-react-lite";

interface ExportWIPBtnProps {
  periodId: ProjectWipExportQueryVariables["period_id"];
}

const ExportWIPBtn = ({ periodId }: ExportWIPBtnProps) => {
  const [fetch] = useProjectWipExportLazyQuery({
    onCompleted(data) {
      const projectsStatusExport = data?.projectWipExport;

      if (projectsStatusExport) {
        window.location.href = projectsStatusExport;
      }
    },
    ...onError(),
  });

  return (
    <MenuItem
      onClick={() =>
        fetch({
          variables: { period_id: periodId },
        })
      }
    >
      {t`Work in progress`}
    </MenuItem>
  );
};

export default observer(ExportWIPBtn);
